module.exports = __webpack_public_path__ + "static/media/[可怜]@2x.7995f927.png";